<template>
  <div class="card h-100 d-flex">
    <div v-if="hike.photos && hike.photos.length" class="card-img-left">
      <router-link :to="{ name: 'hike', params: { id: hike.id } }" class="text-dark fz-md">
        <img :src="hike.photos[0].url" class="img-fluid" alt="Hike photo" />
      </router-link>
    </div>
    <div class="card-header bg-white no-border text-center">
      <div class="text-center mb-1">
        <small>Сложность:</small>
        <span v-if="hike.difficulty === '1'" class="cursor-pointer" title="Легко">🏔️</span>
        <span v-if="hike.difficulty === '2'" class="cursor-pointer" title="Умеренно сложно">🏔️🏔️</span>
        <span v-if="hike.difficulty === '3'" class="cursor-pointer" title="Сложно">🏔️🏔️🏔️</span>
        <span v-if="hike.difficulty === '4'" class="cursor-pointer" title="Очень сложно">🏔️🏔️🏔️🏔️</span>
        <span v-if="hike.difficulty === '5'" class="cursor-pointer" title="Чрезвычайно сложно">🏔️🏔️🏔️🏔️🏔️</span>
      </div>
      <router-link :to="{ name: 'hike', params: { id: hike.id } }" class="text-dark fz-md">
        <strong>{{ hike.title }}</strong>
      </router-link>
    </div>
    <div class="card-body pt-3 d-flex flex-column">
      <p class="card-text mb-1 text-center text-muted fz-sm">
        {{ hike.description | truncate(100) }}
      </p>
    </div>
    <div class="card-footer" v-if="showActionButtons">
      <router-link class="btn btn-light btn-sm mr-2" :to="{ name: 'hike-add', params: { id: hike.id } }">Редактировать</router-link>
      <button class="btn btn-light btn-sm" @click="confirmDeleteHike(hike.id)">Удалить</button>
    </div>
    <div class="card-footer d-flex justify-content-between text-center align-items-center">
      <p class="card-text mb-1"><strong>{{ hike.distance }} км</strong><br> Дистанция</p>
      <p class="card-text mb-1"><strong>{{ hike.elevation }} м</strong><br> Подъем</p>
      <router-link :to="{ name: 'public-profile', params: { id: hike.submittedBy } }">
        <img v-if="hike.author == 'Renat Galyamov'" class="img-fluid rounded-circle mr-2" width="30" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/zabugorshiki_xs.jpg" alt="">
        <img v-else class="img-fluid rounded-circle mr-2" width="30" :src="`https://ui-avatars.com/api/?name=${hike.author.charAt(0)}&size=30&rounded=true`" alt="">
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hike-card',
  props: {
    hike: {
      type: Object,
      required: true
    },
    showActionButtons: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirmDeleteHike (id) {
      this.$emit('delete', id)
    }
  }
}
</script>
